import { ApiProperty } from "@nestjs/swagger";

export class ReWeighIdRequest {
    @ApiProperty()
    rmReWeighingId: number;
}